<template>
  <div class="product-frame">
    <Content :routeArr="routeArr" />

    <div class="box">
      <!-- 图片展示 -->
      <div class="image-text" v-show="!activeItem.code">
        <ul>
          <li
            :class="['img-card', activeCode == item.code ? 'active-card' : '']"
            :style="{ width: 913 / $store.state.subList.length + 'px' }"
            v-for="item in $store.state.subList"
            :key="item.id"
            @mouseenter="showAll(item)"
            @click="changeList(item)"
          >
            <img :src="URL + item.imgUrl" alt="" />
            <div class="tet">
              <div class="tet_box">
                <h2>{{ item.name }}</h2>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 文字展示 -->
      <div class="text" v-show="activeItem.code">
        <div class="title" v-show="searchData">
          您的搜索内容为 {{ searchData }}，搜索结果如下...
        </div>
        <ul class="nav">
          <li
            :class="['nav-item', activeCode == item.code ? 'on' : '']"
            v-for="item in $store.state.subList"
            :key="item.id"
            @click="changeList(item)"
          >
            {{ item.name }}
          </li>
        </ul>

        <div class="new-list">
          <div
            class="new-item"
            v-for="item in newsList"
            :key="item.id"
            @click="getDetail(item)"
          >
            <img :src="URL + imageLen(item.newsImageUrl)" :alt="item.title" />
            <div class="desc">{{ item.title }}</div>
          </div>
          <div class="new-white" v-show="newsList.length % 4 != 0"></div>
          <div class="new-white" v-show="newsList.length % 4 == 2"></div>
        </div>

        <el-pagination
          style="text-align: center; margin-top: 10px"
          @current-change="handleCurrentChange"
          :current-page.sync="params.pageIndex"
          :page-size="params.pageSize"
          layout="total, prev, pager, next"
          :total="newsTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";

import { sysNewsList } from "../../util/news/news.js";
import { URL } from "../../util/config";
import qs from "qs";
export default {
  data() {
    return {
      URL,
      activeCode: "",
      activeItem: {},
      params: {
        pageIndex: 1,
        pageSize: 12,
        newsCode: "",
        title: "",
      },
      newsList: [],
      newsTotal: 0,
      recommendList: [],
      maxPages: 0,
      moduleTitle: "",
      moduleDesc: "", // 模版渲染的标题以及英文翻译
      tabName: "",
      moduleFlag: 1,
      clickConfig: 0,
      routeArr: [],
      isMobile: sessionStorage.getItem("isMobile"),
      searchData: "",
    };
  },
  components: {
    Content,
  },
  computed: {
    imageLen() {
      return (url) => {
        return url.split(",")[0];
      };
    },
  },
  created() {},
  mounted() {
    this.params.newsCode = this.$store.state.code;

    // 若点击二级字典，则直接触发
    const code = sessionStorage.getItem("childCode");
    if (code) {
      this.$store.state.subList.forEach((ele) => {
        if (ele.code == code) {
          this.changeList(ele);
        }
      });
      sessionStorage.removeItem("childCode");
    } else {
      this.activeCode = this.$store.state.subList[0].code;
    }

    const activeCode = localStorage.getItem("activeCode");
    let searchData = sessionStorage.getItem("key");

    if (searchData) {
      // 若存在关键词搜索，则触发
      this.params.title = searchData;
      this.searchData = searchData;

      this.params.newsCode = this.$store.state.code;
      this.activeItem.code = this.$store.state.code;
      this.activeCode = this.$store.state.code;

      this.getList();
      sessionStorage.removeItem("key");
    } else if (this.isMobile == 1) {
      // 若为手机端 直接跳过分类图片展示
      this.activeItem = this.$store.state.subList[0];
      this.params.newsCode = this.$store.state.code;

      this.getList();
    } else if (activeCode) {
      // 若已点击分类图片展示，刷新或者从产品详情返回时跳过分类图片展示
      this.activeItem = this.$store.state.subList.filter(
        (ele) => ele.code == activeCode
      )[0];
      this.activeCode = activeCode;
      this.params.newsCode = activeCode;

      this.getList();
    }

    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/product" },
    ];
  },
  methods: {
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getList();
    },
    getList() {
      //获取列表
      sysNewsList(this.params).then((res) => {
        if (res.code === 0) {
          this.newsList = res.data.list;
          this.newsTotal = res.data.total;
          this.maxPages = res.data.totalPages;
        }
      });
    },
    // 样式展示
    showAll(item) {
      this.activeCode = item.code;
    },
    // nav 改变事件
    changeList(item) {
      this.activeItem = item;
      this.activeCode = item.code;
      localStorage.setItem("activeCode", item.code); // 存储激活数据，从详情返回时直接进入第二级菜单

      this.params = {
        newsCode: item.code,
        title: "",
        pageIndex: 1,
        pageSize: 12,
      };
      this.getList();
    },
    getDetail(item) {
      let query = {
        id: item.id,
        num: this.params.pageIndex,
        code: this.params.newsCode,
      };
      this.$router.push("/productDetail?" + qs.stringify(query));
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.product-frame {
  .box {
    width: 1200px;
    margin: 60px auto;

    .image-text {
      ul {
        display: flex;

        .img-card {
          margin-right: 10px;
          overflow: hidden;
          transition: width 0.6s;
          position: relative;
          &:hover {
            cursor: pointer;
          }

          img {
            width: 287px;
            height: 490px;
          }
          .tet {
            position: absolute;
            left: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 125px;

            .tet_box {
              padding: 20px 16px;
              width: 240px;
              h2 {
                color: #fff;
                font-size: 20px;
                font-weight: 400;
                border-bottom: 1px solid #dedede;
                padding-bottom: 10px;
                margin-bottom: 10px;
              }
            }
          }
        }

        .active-card {
          width: 287px !important;
        }
      }
    }

    .text {
      .nav {
        display: flex;
        justify-content: space-evenly;

        .nav-item {
          font-size: 18px;
          line-height: 40px;
          position: relative;

          &::after {
            content: "";
            display: inline-block;
            width: 0;
            height: 2px;
            background-color: $theme;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            transition: width 0.3s;
          }

          &:hover {
            cursor: pointer;
            color: $theme;

            &::after {
              width: 100%;
            }
          }
        }
        .on {
          color: $theme;
        }
      }
      .new-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        text-align: center;
        margin-top: 60px;

        .new-item {
          width: 273px;
          margin-bottom: 10px;
          transition: all 0.3s;
          &:hover {
            cursor: pointer;
            box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
          }

          img {
            width: 100%;
            height: 273px;
            display: block;
          }
          .desc {
            margin-bottom: 10px;
          }
        }
        .new-white {
          width: 273px;
        }
      }
    }
  }
}
.content {
  width: 1200px;
  margin: 0 auto;

  &::before {
    content: "";
    display: table;
  }

  p {
    border-left: 5px $theme solid;
    font-size: 22px;
    padding-left: 20px;
    margin-top: 40px;
    line-height: 22px;
  }

  .con-desc,
  .recommed {
    padding: 25px;
    font-size: 14px;
    line-height: 28px;
    color: #666666;
  }
  .recommed {
    display: flex;
    text-align: center;
    margin-top: 20px;
    .re-item {
      width: 24%;
      margin-right: 10px;
      transition: all 0.3s;
      &:hover {
        cursor: pointer;

        .desc {
          color: $theme;
        }
      }

      img {
        width: 100%;
        height: 273px;
        display: block;
      }
      .desc {
        margin-bottom: 10px;
      }
    }
  }
}
@media (max-width: 1300px) {
  .product-frame .box {
    width: 1000px;
  }
}
@media (max-width: 1024px) {
  .product-frame .box {
    width: 100%;
    margin: 0;
    padding: pxToRem(20);
    box-sizing: border-box;

    .text {
      .nav {
        flex-wrap: wrap;

        .nav-item {
          font-size: pxToRem(14);
          padding: 0 pxToRem(10);
        }
      }
      .new-list {
        margin-top: pxToRem(30);
        justify-content: space-between;
        .new-item {
          width: pxToRem(150);

          img {
            height: pxToRem(150);
          }
        }
        .new-white {
          width: pxToRem(150);
        }
      }
    }
  }
}
</style>
